import { useState, useEffect } from 'react';
import { getUserLevel } from './../utils/constants';

const useUserLevel = () => {
    const [userLevel, setUserLevel] = useState<number>(getUserLevel());
    useEffect(() => {
        const checkUserLevel = () => {
            const currentLevel = getUserLevel();
            if (currentLevel !== userLevel) {
                setUserLevel(currentLevel);
            }
        };
        const intervalId = setInterval(checkUserLevel, 1000);
        return () => clearInterval(intervalId);
    }, [userLevel]);

    return userLevel;
};

export default useUserLevel;